module.exports = __webpack_public_path__ + "img/redCross.11df6185.svg";